import React, {useEffect} from 'react';

import {MonitorServicesModal} from 'components/ais/monitor-services-card/monitor-services-modal';
import {Table} from 'components/table';
import {ITableScroll} from 'components/table/table';
import {setFilter} from 'modules/data/data-actions';
import {selectFilterEntityData} from 'modules/data/data-selectors';
import {EEntityType} from 'shared/constants/entities';
import {useQueryParams} from 'shared/utils/query-params';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

import {MONITOR_SERVICE_FILTER_QUERY_PARAM} from './monitor-service-page.constants';

export interface IMonitorServicesPageProps {
    url: string;
    hideTitle?: boolean;
    entityType?: EEntityType;
    entityName: string;
    scroll?: ITableScroll;
    hasEntity?: boolean;
    handleFormClose: () => void;
}

export const MonitorServicesPage = ({
    hasEntity, scroll, url, hideTitle, entityType, entityName, handleFormClose,
}: IMonitorServicesPageProps) => {
    const tableFilters = useAppSelector(selectFilterEntityData(entityName));
    const dispatch = useAppDispatch();

    const {getQueryParam} = useQueryParams();
    const ticketIdFilter = getQueryParam(MONITOR_SERVICE_FILTER_QUERY_PARAM);

    useEffect(() => {
        if (tableFilters && !tableFilters?.loading) {
            dispatch(setFilter({entityName, data: {...tableFilters?.data, ticketIdFilter}}));
        }
    }, [ticketIdFilter, tableFilters?.loading]);

    return (
        <>
            <Table
                hideTitle={hideTitle}
                entityName={entityName}
                url={url}
                entityType={entityType}
                scroll={scroll}
                overrideTableFilters={{ticketIdFilter}}
            />
            <MonitorServicesModal
                entityName={entityName}
                visible={!!hasEntity}
                onFormClose={handleFormClose}
            />
        </>
    );
};
